import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import GeoJSON from 'ol/format/GeoJSON';
import { BsModalRef } from 'ngx-bootstrap/modal';
import KML from 'ol/format/KML';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { Layer, VectorLayerDMTR } from 'src/app/menu/view-menu/layer';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { UserSettingsService } from 'src/app/services/userSettings.service';
import { UserLayerTypes } from 'src/app/models/EnumTypes';
import LineString from 'ol/geom/LineString';
import { Circle, Fill, RegularShape, Stroke, Style } from 'ol/style';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { PointsService } from 'src/app/services/points.service';
import { UserLayer } from 'src/app/models/UserSettings';
import { CoordenateService } from 'src/app/services/coordenate.service';
import { cloneDeep } from 'lodash';
import { ExportDataService } from 'src/app/services/export-data';

@Component({
  selector: 'app-import-user-layer',
  templateUrl: './import-user-layer.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class ImportUserLayerComponent implements OnInit {
  layerName: string;
  @Input() file: File;
  constructor(public bsModalRef : BsModalRef,
  public globalSelectionService:   GlobalSelectionControlService,
  public http: HttpClient,
  public endpointsService: EndpointsService,
  private userSettingsService: UserSettingsService,
  private pointsService: PointsService,
  private rcsControl: CoordenateService
  ) { }

  ngOnInit(): void {
  }


  drawOnMap(){
    const reader = new FileReader();
    let thisVar = this;

    reader.onload = function(e: any) {
      if(thisVar.file.name.split(".")[1] == "kml"){
        const kmlText = e.target.result;
        thisVar.drawKML(kmlText);
      }
      else{
        thisVar.drawShapeFile();
      }
    };
    reader.readAsText(this.file);

  }
  drawKML(kmlText:string){
    const kmlFormat = new KML();
    let features = kmlFormat.readFeatures(kmlText,{
      featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
      dataProjection: 'CRS:84'});

    for (const feature of features){
      if (feature.get(ExportDataService.KML_NAVAID_NAME_PROPERTY) !== undefined){
        feature.set("name", feature.get(ExportDataService.KML_NAVAID_NAME_PROPERTY));
        feature.unset(ExportDataService.KML_NAVAID_NAME_PROPERTY);
      } else if (feature.get(ExportDataService.KML_CP_NAME_PROPERTY) !== undefined){
        feature.set("name", feature.get(ExportDataService.KML_CP_NAME_PROPERTY));
        feature.unset(ExportDataService.KML_CP_NAME_PROPERTY);
      }
    }

    let vectorSource = new VectorSource({
      features: features,
    });
    this.drawLayerOnMap(kmlText,UserLayerTypes.KML,vectorSource);
  }
  drawShapeFile(){
    const formData = new FormData();
    formData.append('file',this.file);
    this.http.post(this.endpointsService.getGeoJsonFromShapeFile,
      formData,
      this.endpointsService.httpOptions
    ).subscribe(geoJson =>{
      const vectorSource = new VectorSource({
        features: new GeoJSON().readFeatures(geoJson,{
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
          dataProjection: 'CRS:84'}),
      });
      this.drawLayerOnMap(geoJson,UserLayerTypes.SHAPEFILE,vectorSource)
    })

  }
  drawLayerOnMap(data:any,type:string,vectorSource: VectorSource){
    let labels: string[] = [];
    const featureProperties = vectorSource.getFeatures()[0].getProperties();
    for (const key in featureProperties) {
      if (key != 'geometry' && key != 'elevationLegendPos' && key != 'color') {
        labels.push(key);
      }
    }

    const vectorLayer = new VectorLayerDMTR({
      source: vectorSource,
    });
    let idLayer: number;
    if(typeof data == 'string'){
      idLayer = this.userSettingsService.addUserLayerToUserSettings(data,type,this.layerName, labels);
    }
    else{
       idLayer = this.userSettingsService.addUserLayerToUserSettings(JSON.stringify(data),type,this.layerName, labels);
    }
    let layer: Layer = {
      id: JSON.stringify(idLayer),
      name: this.layerName,
      visible: true, image:"" ,
      olLayer: vectorLayer
    }
    let userLayer :UserLayer= this.userSettingsService.userSettings.userLayers.find((userLayer:UserLayer) => idLayer == userLayer.id);
    if(type == UserLayerTypes.SHAPEFILE)
      this.pointsService.changeUserLayerFeaturesStyle(layer.olLayer.getSource().getFeatures(), userLayer);

    this.globalSelectionService.userLayer.childLayers[0].addLayers([layer]);
  }
}

